<template>
  <footer :class="positionFixed ? 'position-bottom' : ''">
    <div
      v-if="clientStore.id"
      class="mx-auto max-w-7xl px-6 py-6 md:flex md:items-center md:justify-between lg:px-8"
    >
      <div class="mt-8 order-1 mr-12">
        <router-link
          :to="{ name: 'imprint', params: { slug: clientStore.slug } }"
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.about.imprint.item.title") }}
          </p>
        </router-link>
      </div>
      <div class="mt-8 order-1 mr-12">
        <router-link
          :to="{ name: 'termsOfService', params: { slug: clientStore.slug } }"
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.about.terms.of.use.item.title") }}
          </p>
        </router-link>
      </div>
      <div class="mt-8 order-1">
        <router-link
          :to="{ name: 'privacy', params: { slug: clientStore.slug } }"
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.screen.about.section.privacy.tile") }}
          </p>
        </router-link>
      </div>
    </div>
    <div
      v-else
      class="mx-auto max-w-7xl px-6 py-6 flex items-center justify-between lg:px-8"
    >
      <div class="mt-8 order-1 mr-12">
        <a
          href="https://www.mein-phileo.de/info/impressum"
          data-no-external-modal
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.about.imprint.item.title") }}
          </p>
        </a>
      </div>
      <div class="mt-8 order-1 mr-12">
        <a
          v-if="false"
          data-no-external-modal
          href="https://www.mein-phileo.de/terms"
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.about.terms.of.use.item.title") }}
          </p>
        </a>
      </div>
      <div class="mt-8 order-1">
        <a
          href="https://www.mein-phileo.de/info/datenschutz"
          data-no-external-modal
          target="_blank"
          class="hover:underline decoration-2 underline-offset-4 decoration-bkk-100 inline-flex"
        >
          <p class="text-small underline pb-1">
            {{ $t("profile.screen.about.section.privacy.tile") }}
          </p>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { useClientStore } from "../../../store/v2/client";

export default {
  name: "FooterLinks",
  props: {
    positionFixed: Boolean,
  },
  setup() {
    const clientStore = useClientStore();

    return {
      clientStore,
    };
  },
  async mounted() {
    if (!this.$route.params.slug) {
      return;
    }

    await this.clientStore
      .getClient(null, this.$route.params.slug)
      .then(() => {
        this.isLoading = false;
      })
      .catch((err) => {
        this.$userAuthenticator.logout();
        this.$router.push({
          name: "maintenancePage",
        });
      });
  },
};
</script>
<style>
@media (min-width: theme("screens.lg")) {
  footer.position-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
</style>
